import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export enum BoardMeetingState {
  DRAFT = "draft",
  CALL = "call",
  CALLED = "called",
  OPENED = "opened",
  ONGOING = "ongoing",
  ENDED = "ended",
  CLEANING = "cleaning",
  REVIEW = "review",
  COMPLETE = "complete",
}

export const boardMeetingStateTimeline: BoardMeetingState[] = [
  BoardMeetingState.DRAFT,
  BoardMeetingState.CALL,
  BoardMeetingState.CALLED,
  BoardMeetingState.OPENED,
  BoardMeetingState.ONGOING,
  BoardMeetingState.ENDED,
  BoardMeetingState.CLEANING,
  BoardMeetingState.REVIEW,
  BoardMeetingState.COMPLETE,
];

const optionalDate = z.coerce.date().optional();

// When the meeting was last set to each state
export const boardMeetingStateChangedAtSchema = z.object({
  draft: optionalDate,
  call: optionalDate,
  called: optionalDate,
  opened: optionalDate,
  ongoing: optionalDate,
  ended: optionalDate,
  cleaning: optionalDate,
  review: optionalDate,
  complete: optionalDate,
});

export const boardMeetingSchema = surrealRecordSchema.extend({
  name: z.string(),
  date: z.coerce.date(),
  location: z.string().optional(),
  state: z.nativeEnum(BoardMeetingState),
  stateChangedAt: boardMeetingStateChangedAtSchema.default({}),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BoardMeeting = z.infer<typeof boardMeetingSchema>;
